import {useEffect} from 'react';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {RootState} from '../../redux/store';
import {useDispatch, useSelector} from 'react-redux';
import {selectUser} from '../../redux/slices/userSlice';
import {setWelcomeMultiClientTabState} from '../../redux/slices/pageViewStateSlice';
import {setShowModal} from '../../redux/slices/unSaveChangesModalSlice';
import {
  setShowBudgetTrackerDeleteToast,
  setShowBudgetTrackerModal,
  setViewProjectName,
} from '../../redux/slices/budgetTrackerSlice';
import {getUTCDateTimeForDisplay} from '../../utils/utils';
import {ReactComponent as BackgroundImage} from '../../assests/svg/multi-client-header-bg.svg';
import {AurLightTooltip} from '../common/aur-light-tooltip/aur-light-tooltip';
import AurTabMenu, {AurTab} from '../common/aur-tab-menu/AurTabMenu';
import ClientViewTab from './welcome-screen-multi-client/client-view/ClientViewTab';
import ProjectViewTab from './welcome-screen-multi-client/project-view/ProjectViewTab';
import {useAnalytics} from '../../hooks/useAnalytics';
import {
  GA_EVENT_NAMES,
  GA_SUBPAGE_TYPE,
} from '../../constants/analyticsConstants';

const WelcomeScreenMultiClient = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const {trackGAEvent} = useAnalytics();
  const selectedTab = useSelector(
    (state: RootState) => state.pageViewState.welcomeMultiClientTab
  );

  useEffect(() => {
    dispatch(setViewProjectName(''));
    localStorage.setItem('currentPath', '');
    dispatch(setShowModal(false));
    dispatch(setShowBudgetTrackerModal(false));
    dispatch(setShowBudgetTrackerDeleteToast(false));
  }, []);

  const handleTabChange = (index: number) => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
      subPage: {
        subpage_name:
          index === 0
            ? t('gaTracking.welcomeScreen.clientListView')
            : t('gaTracking.welcomeScreen.projectListView'),
        subpage_type: GA_SUBPAGE_TYPE.TAB,
      },
    });
    dispatch(setWelcomeMultiClientTabState(index));
  };

  const tabs: AurTab[] = [
    {
      header: {
        text: t('welcomeScreenMultiClient.clientView'),
      },
      content: <ClientViewTab />,
      index: 0,
    },
    {
      header: {
        text: t('welcomeScreenMultiClient.projectView'),
      },
      content: <ProjectViewTab />,
      index: 1,
    },
  ];

  return (
    <>
      <Box className="welcome-screen-multi-client">
        <Box className="header">
          <Box className="header-items">
            <Typography
              className="typo-text display2_size"
              data-testid="welcome-text"
            >
              {t('welcomeScreenMultiClient.welcomeBack')}
              &nbsp;
              {user?.givenname}
            </Typography>
            <Box className="data-current-as-of">
              <span className="date-text" tabIndex={0}>
                {t('welcomeScreenMultiClient.dateCurrenctAsOf')}&nbsp;
              </span>
              <AurLightTooltip title={t('common.yearMonthDate')}>
                <span
                  className="date-value"
                  tabIndex={0}
                  aria-label={getUTCDateTimeForDisplay(new Date())}
                >
                  {getUTCDateTimeForDisplay(new Date())}
                </span>
              </AurLightTooltip>
            </Box>
          </Box>
          <BackgroundImage className="background-image" aria-hidden="true" />
        </Box>

        <Box className="body">
          <Box className="tabs">
            <AurTabMenu
              tabs={tabs}
              width={'100%'}
              forceRenderTabs={true}
              defaultTab={selectedTab}
              onTabChange={handleTabChange}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default WelcomeScreenMultiClient;
